import React from 'react'
import Layout from '../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ChargeAnalyzerSystem = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 1500,        // ✅ slower transition (2 seconds)
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500 // ✅ stays 3 seconds before next slide (optional)
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpulpinstrument%2Fimg%2F1772781749658_Screenshot%202026-03-06%20125137.png?alt=media&token=59002a86-1356-4941-914e-c2c516b9e196',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpulpinstrument%2Fimg%2F1772781749658_Screenshot%202026-03-06%20125137.png?alt=media&token=59002a86-1356-4941-914e-c2c516b9e196'
    ];

    return (
        
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/paperTesting">Paper Testing</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Charge Analyzer System </h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Charge Analyzer System </h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    CAS accurately measures dissolved colloidal / ionic charge of a liquid using streaming current
                                    principle which is comparable to the Zeta Potential in dilution. The charge demand is determined
                                    with Polyelectrolyte titration to the isoelectric point either manually or by use of an automatic titrator.
                                    CAS is having the features  like user friendly operation. Same volume required for analysis and
                                    Measurement is 10ml. Sturdy housing for easy mobility, quick set of and long term stability. Detachable
                                    probe for facilitate cleaning and prevent corrosion. The instrument is easy to operate and it facilitated
                                    with built-in automatic titrator.

                                    <br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Fiber Potential Onilne (FPO)"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default ChargeAnalyzerSystem